import {
  BodyText,
  Icon,
  IconNameType,
  Stack,
  Tooltip,
} from '@servicetitan/design-system';
import React, { useEffect, useRef, useState } from 'react';
import SearchResultBadge from '../SearchResultBadge';
import styles from './CustomerSearchResultName.module.css';

interface CustomerSearchResultNameProps {
  iconName: IconNameType;
  content: string;
  badgeCount?: number;
  className?: string;
  renderBadge?: React.ReactNode;
}

export const CustomerSearchResultName = ({
  iconName,
  content,
  badgeCount,
  className,
  renderBadge,
}: CustomerSearchResultNameProps) => {
  const [isOverflow, setIsOverflow] = useState(false);
  const nameTooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = nameTooltipRef.current;
    if (element) {
      if (element.scrollWidth > element.clientWidth) {
        setIsOverflow(true);
      } else {
        setIsOverflow(false);
      }
    }
  }, [content]);

  const Wrapper = isOverflow ? Tooltip : React.Fragment;

  return (
    <div className={className}>
      <Stack alignItems='center' spacing={1}>
        <Icon className='c-neutral-100' name={iconName} size='16px' />
        <Stack.Item>
          <Wrapper
            {...(isOverflow && {
              direction: 'top',
              text: content,
              className: styles.nameTooltip,
            })}
          >
            <BodyText size='small' className={styles.name} ref={nameTooltipRef}>
              {content}
            </BodyText>
          </Wrapper>
        </Stack.Item>
        {!!badgeCount && <SearchResultBadge count={badgeCount} />}
        {!badgeCount && renderBadge}
      </Stack>
    </div>
  );
};
